import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, timer } from 'rxjs';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { modules } from 'src/app/globals';
import { QuillNoteTypeMismatchDialogComponent } from 'src/app/lib/shared/components/dialog/quill-note-type-mismatch-dialog/quill-note-type-mismatch-dialog.component';
import { DOUBLET_PROVIDER_SERVICE, IDoubletProviderService } from 'src/app/lib/shared/interfaces';

@Component({
  selector: 'app-location-form',
  templateUrl: './location-form.component.html',
  styleUrls: ['./location-form.component.css']
})
export class LocationFormComponent implements OnInit {

  @Input() editMode: boolean = true;
  @Input() appearance: 'standard' | 'fill' | 'outline' = 'fill';

  formGroup: FormGroup;

  modules = modules;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Optional() @Inject(DOUBLET_PROVIDER_SERVICE) public doubletService: IDoubletProviderService,
    private _controlContainer: ControlContainer,
    private _dialog: MatDialog
  ) { }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as FormGroup;

    if (this.doubletService) this._subscriptions.push(this.locationPartControl.valueChanges.pipe(debounceTime(1000)).subscribe(value => {
      this.doubletService.setSearchString(value);
    }));

    this._subscriptions.push(...[
      this.locationInfoControl.valueChanges.pipe(take(1), takeUntil(timer(2000))).subscribe((note: string) => {
        if(typeof note !== 'string') return;
        if (note.startsWith('{"ops":[{')) {
          this._dialog.open(QuillNoteTypeMismatchDialogComponent, {
            panelClass: 'no-padding-dialog-container',
            data: note
          }).afterClosed().subscribe((htmlResult: string) => {
            if (htmlResult) {
              this.locationInfoControl.setValue(htmlResult);
              this.locationInfoControl.markAsDirty();
            }
          });
        }
      })
    ]);
  }

  setAutoLocationNumber() {

  }

  get locationInfoControl(): AbstractControl {
    return this.formGroup.controls['locationinfo'];
  }
  get locationParentControl(): AbstractControl {
    return this.formGroup.controls['locationparent'];
  }
  get locationPartControl(): AbstractControl {
    return this.formGroup.controls['locationpart'];
  }

}
